import Vue from 'vue'
import Router from 'vue-router'
const footnav = resolve => require(['@/components/footnav.vue'],resolve)
const home = resolve => require(['@/views/home/home.vue'],resolve)
const address = resolve => require(['@/views/login/address.vue'],resolve)
const login = resolve => require(['@/views/login/login.vue'],resolve)
const register = resolve => require(['@/views/login/register.vue'],resolve)
const message = resolve => require(['@/views/home/message.vue'],resolve)
const video = resolve => require(['@/views/home/video.vue'],resolve)
const homeImg = resolve => require(['@/views/home//homeChild/homeImg.vue'],resolve)
const goodsImg = resolve => require(['@/views/home//homeChild/goodsImg.vue'],resolve)
const goods = resolve => require(['@/views/goods/goods.vue'],resolve)
// const test = resolve => require(['@/views/goods/test.vue'],resolve)
const goodsDetail = resolve => require(['@/views/goods/goodsDetail.vue'],resolve)
const car = resolve => require(['@/views/car/car.vue'],resolve)
const userCard = resolve => require(['@/views/car/userCard.vue'],resolve)
const myself = resolve => require(['@/views/myself.vue'],resolve)
const addressList = resolve => require(['@/views/address/addressList.vue'],resolve)
const map = resolve => require(['@/views/address/addressChild/map.vue'],resolve)
const myOrder = resolve => require(['@/components/mine/myOrder.vue'],resolve)
const myFootprint = resolve => require(['@/components/mine/myFootprint.vue'],resolve)
const orderConfirm = resolve => require(['@/views/order/orderConfirm.vue'],resolve)
const orderDetail = resolve => require(['@/views/order/orderDetail.vue'],resolve)
const homeCard = resolve => require(['@/components/mine/homeCard.vue'],resolve)
const goodsEvalute = resolve => require(['@/components/mine/goodsEvalute.vue'],resolve)
const offLine = resolve => require(['@/components/offLine.vue'],resolve)
const notFound = resolve => require(['@/components/notFound.vue'],resolve)
const progressDetail = resolve => require(['@/views/order/progressDetail.vue'],resolve)
const clear = resolve => require(['@/views/clear.vue'],resolve)
const blank = resolve => require(['@/views/home/blankPage.vue'],resolve)
const beans = resolve => require(['@/views/beans/content.vue'],resolve)
const explain = resolve => require(['@/views/beans/explain.vue'],resolve)
const recordList = resolve => require(['@/views/beans/list.vue'],resolve)
const equity = resolve => require(['@/views/beans/equity.vue'],resolve)
const equityDetail = resolve => require(['@/views/beans/equityDetail.vue'],resolve)
const test = resolve => require(['@/views/beans/test.vue'],resolve)
const medal = resolve => require(['@/views/beans/medal.vue'],resolve)
const bannerView = resolve => require(['@/components/mine/bannerView.vue'],resolve)
const traceBack = resolve => require(['@/views/traceBack/index.vue'],resolve)
Vue.use(Router)

export default new Router({
  routes: [
     {
      path: '/offLine',
      name: 'offLine',
      component: offLine,
      meta: { navShow: false}
    },
    {
      path: '/notFound',
      name: 'notFound',
      component: notFound,
      meta: { navShow: false}
    },
    {
      path: '/',
      name: 'footnav',
      component: footnav,
      meta: { navShow: true}
    },
    {
      path: '/home',
      name: 'home',
      // component: home,
      component: home,
      meta: { navShow: true},
    },
    {
      path: '/home/blank',
      name: 'blank',
      component: blank
    },
    {
      path: '/home/bannerView',
      component: bannerView
    },
    {
      path: '/login',
      name: 'login',
      // component: home,
      component: login,
      meta: { navShow: false},
    },
    {
      path: '/register',
      name: 'register',
      // component: home,
      component: register,
      meta: { navShow: false},
    },
    {
      path: '/address',
      name: 'address',
      // component: home,
      component: address,
      meta: { navShow: false},
    },
    {
      path: '/equity',
      name: 'equity',
      // component: home,
      component: equity,
      meta: { navShow: false},
    },
    {
      path: '/equityDetail',
      name: 'equityDetail',
      // component: home,
      component: equityDetail,
      meta: { navShow: false},
    },
    {
      path: '/test',
      name: 'test',
      // component: home,
      component: test,
      meta: { navShow: false},
    },
    {
      path: '/message',
      name: 'message',
      // component: home,
      component: message,
      meta: { navShow: false},
    },
    {
      path: '/video',
      name: 'video',
      // component: home,
      component: video,
      meta: { navShow: false},
    },
    {
      path: '/homeImg',
      name: 'homeImg',
      // component: home,
      component: homeImg,
      meta: { navShow: false},
    },
    {
      path: '/goodsImg',
      name: 'goodsImg',
      // component: home,
      component: goodsImg,
      meta: { navShow: false},
    },
    {
      path: '/car',
      name: 'car',
      component: car,
      meta: { navShow: true},
    },
    {
      path: '/userCard',
      name: 'userCard',
      component: userCard,
      meta: { navShow: false},
    },
    {
      path: '/myself',
      name: 'myself',
      component: myself,
      meta: { navShow: true},
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: goodsDetail, 
      meta: { 
        navShow: false,
        keepAlive: true
      },
    },
    {
      path: '/goods',
      name: 'goods',
      component: goods,
      meta: { 
        navShow: true,
        keepAlive: true
      },
    },
    {
      path: '/test',
      name: 'test',
      component: test,
      meta: { navShow: false},
    },
    {
      path: '/addressList',
      name: 'addressList',
      component: addressList,
      meta: { navShow: false},
    },
    {
      path: '/map',
      name: 'map',
      component: map,
      meta: { navShow: false},
    },
    {
      path: '/progressDetail',
      name: 'progressDetail',
      component: progressDetail
    },
    {
      path: '/clear',
      component: clear
    },
    {
      path: '/traceBack',
      component: traceBack
    },
    { path: '/myOrder',name:'myOrder',component: myOrder },
    { path: '/myFootprint', component: myFootprint},
    { path: '/homeCard', component: homeCard},
    { path: '/orderConfirm', name: 'orderConfirm', component: orderConfirm},
    { path: '/orderDetail', name: 'orderDetail',component: orderDetail,meta: { navShow: true}},
    { path: '/goodsEvalute', component: goodsEvalute},
    { path: '/beans', component: beans},
    { path: '/explain', component: explain},
    { path: '/recordList', component: recordList},
    { path: '/myself/medal', component: medal}
  ],
  scrollBehavior (to, from, savedPosition) {
    // if(to.path!='/goods'){
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      // }
    }
    
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js